// extracted by mini-css-extract-plugin
export default {"root":"Law25Banner_root__2t2aY","icon":"Law25Banner_icon__J2QSx","text":"Law25Banner_text__8OjKS"};